module.exports = __webpack_public_path__ + "static/media/Q1_Back_Right.1b7bb926.png";